"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseVisualization = void 0;
var tslib_1 = require("tslib");
var sdk_model_1 = require("@gooddata/sdk-model");
var react_1 = tslib_1.__importDefault(require("react"));
var react_dom_1 = require("react-dom");
var uuid_1 = require("uuid");
var Visualization_1 = require("../interfaces/Visualization");
var VisualizationCatalog_1 = require("./VisualizationCatalog");
var isEmpty_1 = tslib_1.__importDefault(require("lodash/isEmpty"));
var isEqual_1 = tslib_1.__importDefault(require("lodash/isEqual"));
var noop_1 = tslib_1.__importDefault(require("lodash/noop"));
var omit_1 = tslib_1.__importDefault(require("lodash/omit"));
var BaseVisualization = /** @class */ (function (_super) {
    tslib_1.__extends(BaseVisualization, _super);
    function BaseVisualization(props) {
        var _this = _super.call(this, props) || this;
        _this.visElementId = uuid_1.v4();
        _this.executionFactory = props.backend.workspace(props.projectId).execution();
        return _this;
    }
    BaseVisualization.prototype.componentWillUnmount = function () {
        this.visualization.unmount();
    };
    BaseVisualization.prototype.UNSAFE_componentWillReceiveProps = function (nextProps) {
        var newDerivedBucketItemsChanged = !isEmpty_1.default(nextProps.newDerivedBucketItems) &&
            !isEqual_1.default(nextProps.newDerivedBucketItems, this.props.newDerivedBucketItems);
        if (newDerivedBucketItemsChanged) {
            this.triggerPlaceNewDerivedBucketItems(nextProps);
            return;
        }
        var visualizationClassChanged = !isEqual_1.default(nextProps.visualizationClass, this.props.visualizationClass);
        var referencePointChanged = BaseVisualization.bucketReferencePointHasChanged(this.props.referencePoint, nextProps.referencePoint);
        var propertiesChanged = BaseVisualization.propertiesHasChanged(this.props.referencePoint, nextProps.referencePoint);
        if (visualizationClassChanged) {
            this.visElementId = uuid_1.v4();
            this.setupVisualization(nextProps);
        }
        if (referencePointChanged || visualizationClassChanged) {
            this.triggerExtendedReferencePointChanged(nextProps, 
            // only pass current props if the visualization class is the same (see getExtendedReferencePoint JSDoc)
            visualizationClassChanged ? undefined : this.props);
        }
        else if (propertiesChanged) {
            this.triggerPropertiesChanged(nextProps);
        }
    };
    BaseVisualization.prototype.componentDidMount = function () {
        this.setupVisualization(this.props);
        this.updateVisualization();
        this.triggerExtendedReferencePointChanged(this.props);
    };
    BaseVisualization.prototype.componentDidUpdate = function () {
        if (this.props.isMdObjectValid) {
            this.updateVisualization();
        }
    };
    BaseVisualization.prototype.render = function () {
        return react_1.default.createElement("div", { key: this.visElementId, style: { height: "100%" }, className: this.getClassName() });
    };
    BaseVisualization.prototype.getVisElementClassName = function () {
        return "gd-vis-" + this.visElementId;
    };
    BaseVisualization.prototype.getClassName = function () {
        return "gd-base-visualization " + this.getVisElementClassName();
    };
    BaseVisualization.prototype.setupVisualization = function (props) {
        var visualizationClass = props.visualizationClass, environment = props.environment, locale = props.locale, featureFlags = props.featureFlags, projectId = props.projectId, configPanelClassName = props.configPanelClassName, renderer = props.renderer;
        if (this.visualization) {
            this.visualization.unmount();
        }
        var visUri = sdk_model_1.visClassUrl(visualizationClass);
        var visFactory;
        try {
            visFactory = this.props.visualizationCatalog.forUri(visUri).getFactory();
        }
        catch (e) {
            // eslint-disable-next-line no-console
            console.error("Error: unsupported visualization type - " + visUri);
        }
        if (visFactory) {
            var constructorParams = {
                projectId: projectId,
                locale: locale,
                environment: environment,
                backend: props.backend,
                element: "." + this.getVisElementClassName(),
                configPanelElement: "." + configPanelClassName,
                callbacks: {
                    afterRender: props.afterRender,
                    onLoadingChanged: props.onLoadingChanged,
                    onError: props.onError,
                    onExportReady: props.onExportReady,
                    pushData: props.pushData,
                    onDrill: props.onDrill,
                },
                featureFlags: featureFlags,
                visualizationProperties: sdk_model_1.insightProperties(props.insight),
                renderFun: renderer,
            };
            this.visualization = visFactory(constructorParams);
        }
    };
    BaseVisualization.prototype.updateVisualization = function () {
        if (!this.visualization) {
            return;
        }
        this.visualization.update(this.getVisualizationProps(), this.props.insight, this.props.insightPropertiesMeta, this.executionFactory);
    };
    BaseVisualization.prototype.triggerPlaceNewDerivedBucketItems = function (props) {
        var newDerivedBucketItems = props.newDerivedBucketItems, referencePoint = props.referencePoint, onNewDerivedBucketItemsPlaced = props.onNewDerivedBucketItemsPlaced;
        if (this.visualization && referencePoint && newDerivedBucketItems && onNewDerivedBucketItemsPlaced) {
            this.visualization
                .addNewDerivedBucketItems(referencePoint, newDerivedBucketItems)
                .then(onNewDerivedBucketItemsPlaced);
        }
    };
    BaseVisualization.prototype.triggerExtendedReferencePointChanged = function (newProps, currentProps) {
        var _this = this;
        var newReferencePoint = newProps.referencePoint, onExtendedReferencePointChanged = newProps.onExtendedReferencePointChanged, onSortingChanged = newProps.onSortingChanged;
        if (this.visualization && newReferencePoint && onExtendedReferencePointChanged) {
            this.visualization
                .getExtendedReferencePoint(newReferencePoint, currentProps && currentProps.referencePoint)
                .then(function (extendedReferencePoint) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                var sortConfig;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            onExtendedReferencePointChanged(extendedReferencePoint);
                            return [4 /*yield*/, this.visualization.getSortConfig(extendedReferencePoint)];
                        case 1:
                            sortConfig = _a.sent();
                            return [2 /*return*/, onSortingChanged && onSortingChanged(sortConfig)];
                    }
                });
            }); });
        }
    };
    BaseVisualization.prototype.triggerPropertiesChanged = function (newProps) {
        var newReferencePoint = newProps.referencePoint, onSortingChanged = newProps.onSortingChanged;
        // Some of the properties eg. stacking of measures, dual axes influence sorting
        if (this.visualization && newReferencePoint && onSortingChanged) {
            this.visualization.getSortConfig(newReferencePoint).then(onSortingChanged);
        }
    };
    BaseVisualization.bucketReferencePointHasChanged = function (currentReferencePoint, nextReferencePoint) {
        return !isEqual_1.default(omit_1.default(currentReferencePoint, "properties"), omit_1.default(nextReferencePoint, "properties"));
    };
    BaseVisualization.propertiesHasChanged = function (currentReferencePoint, nextReferencePoint) {
        return !isEqual_1.default(currentReferencePoint === null || currentReferencePoint === void 0 ? void 0 : currentReferencePoint.properties, nextReferencePoint === null || nextReferencePoint === void 0 ? void 0 : nextReferencePoint.properties);
    };
    BaseVisualization.prototype.getVisualizationProps = function () {
        return {
            locale: this.props.locale,
            dateFormat: this.props.dateFormat,
            dimensions: {
                width: this.props.width,
                height: this.props.height,
            },
            custom: {
                drillableItems: this.props.drillableItems,
                totalsEditAllowed: this.props.totalsEditAllowed,
            },
            config: this.props.config,
            theme: this.props.theme,
            executionConfig: this.props.executionConfig,
        };
    };
    BaseVisualization.prototype.getInsightWithDrillDownApplied = function (sourceVisualization, drillDownContext) {
        return this.visualization.getInsightWithDrillDownApplied(sourceVisualization, drillDownContext);
    };
    BaseVisualization.prototype.getExecution = function () {
        if (!this.visualization) {
            this.setupVisualization(this.props);
        }
        return this.visualization.getExecution(this.getVisualizationProps(), this.props.insight, this.executionFactory);
    };
    BaseVisualization.defaultProps = {
        visualizationCatalog: VisualizationCatalog_1.FullVisualizationCatalog,
        newDerivedBucketItems: [],
        referencePoint: null,
        onExtendedReferencePointChanged: noop_1.default,
        onNewDerivedBucketItemsPlaced: noop_1.default,
        isMdObjectValid: true,
        configPanelClassName: Visualization_1.ConfigPanelClassName,
        featureFlags: {},
        renderer: react_dom_1.render,
    };
    return BaseVisualization;
}(react_1.default.PureComponent));
exports.BaseVisualization = BaseVisualization;
//# sourceMappingURL=BaseVisualization.js.map